export const FEEDBACK_SET_LIST = 'FEEDBACK_SET_LIST';
export const FEEDBACK_SET_QUESTIONS = 'FEEDBACK_SET_QUESTIONS';
